import { render, staticRenderFns } from "./BaseManageAccountCmsInput.vue?vue&type=template&id=5a6e8bb2&scoped=true&"
import script from "./BaseManageAccountCmsInput.vue?vue&type=script&lang=js&"
export * from "./BaseManageAccountCmsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e8bb2",
  null
  
)

export default component.exports